<ng-container *ngIf="wrapper">

    <nz-page-header
        nzBackIcon
        [nzTitle]="wrapper.product.name"
        [nzSubtitle]="wrapper.product.productType">
        <nz-page-header-extra>
            <nz-tag [nzColor]="getStatusColor(wrapper.status)">{{wrapper.status}}</nz-tag>
        </nz-page-header-extra>
    </nz-page-header>

    <!-- Premium Stats -->
    <div class="row mb-3">
        <div class="col">
            <nz-card>
                <nz-statistic nzTitle="Active Policies" [nzValue]="wrapper.policyCount"></nz-statistic>
            </nz-card>
        </div>
        <div class="col">
            <nz-card>
                <nz-statistic nzTitle="Premiums Raised" [nzValue]="wrapper.raisedPremium" nzPrefix="R"></nz-statistic>
            </nz-card>
        </div>
        <div class="col">
            <nz-card>
                <nz-statistic nzTitle="Premiums Received" [nzValue]="wrapper.receivedPremium" nzPrefix="R"></nz-statistic>
            </nz-card>
        </div>
        <div class="col">
            <nz-card>
                <nz-statistic
                    nzTitle="Outstanding Premiums"
                    [nzValue]="wrapper.outstandingPremiums"
                    nzPrefix="R"
                    [nzValueStyle]="{ color: wrapper.outstandingPremiums > 0 ? '#ff4d4f' : 'inherit' }">
                </nz-statistic>
            </nz-card>
        </div>
        <div class="col">
            <nz-card>
                <nz-statistic nzTitle="Auto Premium Raises" [nzValue]="wrapper.autoPolicyPremiumRaisedCount"></nz-statistic>
            </nz-card>
        </div>
        <div class="col">
            <nz-card>
                <nz-statistic nzTitle="Schedule Premium Raises" [nzValue]="wrapper.schedulePolicyPremiumRaisedCount"></nz-statistic>
            </nz-card>
        </div>
    </div>

    <!-- Product Details -->
    <div class="row">
        <div class="col">
            <nz-card nzTitle="Product Details">
                <nz-descriptions [nzColumn]="2" nzBordered>
                    <nz-descriptions-item nzTitle="ID">{{wrapper.product.id}}</nz-descriptions-item>
					<nz-descriptions-item nzTitle="Split Payment Day">{{wrapper.product.premiumSplitPaymentDayOfMonth}}</nz-descriptions-item>

					<nz-descriptions-item nzTitle="Name">{{wrapper.product.name}}</nz-descriptions-item>
                    <nz-descriptions-item nzTitle="Lapse Window">{{wrapper.product.lapsedPremiumWindowInMonths}} months</nz-descriptions-item>

					<nz-descriptions-item nzTitle="Description">{{wrapper.product.description}}</nz-descriptions-item>
                    <nz-descriptions-item nzTitle="Max Lapsed In Window">{{wrapper.product.maxAllowedLapsedPremiumsInWindowPeriod}}</nz-descriptions-item>

					<nz-descriptions-item nzTitle="Product Type">{{wrapper.product.productType}}</nz-descriptions-item>
                    <nz-descriptions-item nzTitle="Max Consecutive Lapsed">{{wrapper.product.maxAllowedConsecutiveLapsedPremiums}}</nz-descriptions-item>

					<nz-descriptions-item nzTitle="Benefit Type">{{wrapper.product.benefitType}}</nz-descriptions-item>
					<nz-descriptions-item nzTitle="Benefit Payment File">{{wrapper.product.enableBenefitPaymentFileGeneration ? 'Enabled' : 'Disabled'}}</nz-descriptions-item>

					<nz-descriptions-item nzTitle="Created At">{{wrapper.product.createdAt | date}}</nz-descriptions-item>
					<nz-descriptions-item nzTitle="Last Schedule Upload">{{(wrapper.lastSchedulePolicyPremiumRaisedDate | date) ?? 'Never'}}</nz-descriptions-item>
                </nz-descriptions>
            </nz-card>
        </div>
    </div>
	<br/>
	<br/>

	<div class="d-flex align-items-center justify-content-between mb-2">
		<h5 class="mb-0">Schedules</h5>
		<button nz-button nzType="link" (click)="openCsvFormatModal()">
			<i nz-icon nzType="file-text"></i>
			View CSV Format
		</button>
	</div>
	<nz-upload
		nzType="drag"
		[nzMultiple]="false"
		[nzCustomRequest]="customUpload"
		[nzShowUploadList]="false">
		<p class="ant-upload-drag-icon">
			<i nz-icon nzType="inbox" ></i>
		</p>
		<p class="ant-upload-text">Click or drag file to this area to upload</p>
	</nz-upload>
	<ngb-progressbar *ngIf="uploadProgress || uploadProgress == 0" class="mb-3" [showValue]="true" type="info" [value]="uploadProgress" />

	<div class="row mt-3">
		<div class="col">
			<app-table
				[data]="data"
				[headerClass]="'table-info'"
				[columns]="columnRef"
				[loading]="loading"
				[disablePaging]="true"
				(onRowClick)="doView($event)"
				(onUpdateRequired)="doFetchUploads($event)">
				<ng-template let-row="row" #refUploadedAt><td>{{row.createdAt | date}}</td></ng-template>
				<ng-template let-row="row" #refAgent><td>{{row.uploadedByAgent.username??''}}</td></ng-template>
				<ng-template let-row="row" #refProcessStartedAt><td>{{row.processingStartedAt | date}}</td></ng-template>
				<ng-template let-row="row" #refProcessCompletedAt><td>{{row.processingCompletedAt | date}}</td></ng-template>
				<ng-template let-row="row" #refStatus><td>{{row.status}}</td></ng-template>
				<ng-template let-row="row" #refBankDepositAmount><td>{{row.bankDepositAmount|currency:'ZAR':'symbol-narrow'}}</td></ng-template>
				<ng-template let-row="row" #refTotalPremiumAmount><td>{{row.totalPremiumAmount|currency:'ZAR':'symbol-narrow'}}</td></ng-template>
				<ng-template let-row="row" #refBankBalanceMatch>
					<td *ngIf="row.bankDepositAmount == row.totalPremiumAmount">Match</td>
					<td *ngIf="row.bankDepositAmount > row.totalPremiumAmount">Deposit larger than expected</td>
					<td *ngIf="row.bankDepositAmount < row.totalPremiumAmount">Deposit smaller than expected</td>
				</ng-template>


				<ng-template let-row="row" #refCountOfRecords><td>{{row.countOfRecords|number}}</td></ng-template>
				<ng-template let-row="row" #refCountOfValidRecords><td>{{row.countOfValidRecords|number}}</td></ng-template>
				<ng-template let-row="row" #refCountOfFailedRecords><td>{{row.countOfFailedRecords|number}}</td></ng-template>
				<ng-template let-row="row" #refCountOfInvalidRecords><td>{{row.countOfInvalidRecords|number}}</td></ng-template>
				<ng-template let-row="row" #refRemovedPolicies><td>{{row.removedPolicies|number}}</td></ng-template>
				<ng-template let-row="row" #refAddedPolicies><td>{{row.addedPolicies|number}}</td></ng-template>
				<ng-template let-row="row" #refUpdatedPolicies><td>{{row.updatedPolicies|number}}</td></ng-template>
			</app-table>
		</div>
	</div>
</ng-container>

